import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import { useLanguage } from '../../context/LanguageContext';

const TermsPage = () => {
    const { t } = useLanguage();

    return (
        <Fragment>
            <SEO title={t('pages.terms')} />
            <NavbarS2 hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={t('pages.terms')} pagesub={t('pages.terms')} />
            <section className="pf-terms-section section-padding ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="pf-terms-wrap">
                                <div className="pf-terms-text">
                                    <h2>{t('terms.title')}</h2>
                                    <h3>{t('terms.h1')}</h3>
                                    <p>{t('terms.p1')}</p>
                                    <h3>{t('terms.h2')}</h3>
                                    <p>{t('terms.p2')}</p>
                                    <h3>{t('terms.h3')}</h3>
                                    <p>{t('terms.p3')}</p>
                                    <h3>{t('terms.h4')}</h3>
                                    <p>{t('terms.p4')}</p>
                                    <h3>{t('terms.h5')}</h3>
                                    <p>{t('terms.p5')}</p>
                                    <h3>{t('terms.h6')}</h3>
                                    <p>{t('terms.p6')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default TermsPage;
